export const role = {
  adminGroup: ['admin'],
  financeGroup: ['admin', 'finance'],
  supervisorGroup: ['admin', 'supervisor'],
  managementGroup: ['admin', 'finance', 'supervisor'],
  stockGroup: ['admin', 'supervisor', 'stockKeeper'],
  generalGroup: ['admin', 'supervisor', 'finance', 'stockKeeper']
};

export const reportsPermissions = {
  finance: ['Outlets', 'Invoices', 'Commissions', 'Financial Transactions', 'Credit'],
  stockKeeper: ['Outlets', 'Orders', 'Products', 'Stock Adjustment', 'Return Orders'],
  supervisor: [
    'Outlets',
    'Orders',
    'Products',
    'Stock Adjustment',
    'Return Orders',
    'Invoices',
    'Commissions',
    'Credit'
  ],
  admin: [
    'Outlets',
    'Orders',
    'Products',
    'Stock Adjustment',
    'Return Orders',
    'Invoices',
    'Commissions',
    'Financial Transactions',
    'Credit'
  ]
};

/**
 * Where a user belongs when they land on the app without asking for a page — after
 * signing in, or by following the sidebar brand to "/".
 *
 * The dashboard is the natural home, but every /dashboard/* endpoint in Khufu is
 * restricted to admins, so showing it to anyone else renders a screen of failed
 * requests. Everyone else starts on the orders list, which their role can actually read.
 *
 * The tab must be named. Orders registers routes for each status tab and no index route,
 * so bare "/orders" matches nothing and renders an empty page. "/orders/all" is what the
 * sidebar links to as well.
 */
export const landingPathFor = (userRole?: string) => (userRole === 'admin' ? '/' : '/orders/all');
